import { memo } from "react";
import Button from "../Common/Button";
import { truncateText } from "../../utils/questionUtilities";
import TooltipComponent from "../../components/StudentDashboard/Tooltip/Tooltip";

function FileName({
  row,
  header,
  deleteFile,
  index,
  EditFile,
  disabled = false,
}) {
  const fileStyles = {
    display: "flex",
    gap: "20px",
    justifyContent: "space-between",
    padding: "0px 10px",
    alignItems: "center",
    background: "rgba(68, 3, 191, 0.10)",
    minHeight: "30px",
    fontSize: "12px",
    maxWidth: "300px",
  };

  const buttonStyles = {
    background: "transparent",
    color: "#4403BF",
    border: "1px solid #4403BF",
  };

  return (
    <div
      style={{
        display: "flex",
      }}
    >
      {row[header] !== "" ? (
        <div style={fileStyles}>
          {row[header]?.length > 20 ? (
            <TooltipComponent direction="bottom" TooltipText={row[header]}>
              <span>{truncateText(row[header], 20)}</span>
            </TooltipComponent>
          ) : (
            row[header]
          )}

          {!disabled && (
            <img
              src="/Cross.svg"
              alt="cross"
              style={{ cursor: "pointer" }}
              onClick={() => deleteFile(index)}
            />
          )}
        </div>
      ) : (
        <div className="py-2">
          {!disabled && (
            <Button onClick={() => EditFile(index)} style={buttonStyles}>
              Add Document
            </Button>
          )}
        </div>
      )}
    </div>
  );
}

export default memo(FileName);
